import * as React from 'react';
const { useCallback, forwardRef } = React;
import * as ReactDOM from 'react-dom';
import MaskedInput from 'react-text-mask';

import TextField, { TextFieldProps } from '../text-field';
import {
	Root
} from './styled';


export type FundsRegisterNumberTextFieldProps = {} & TextFieldProps;

const TextMask = (props) => {
	const { inputRef, ...rest } = props;
	const setRef = useCallback(ref => inputRef(ReactDOM.findDOMNode(ref)), []);

  return (
    <MaskedInput
      {...rest}
      ref={setRef}
      mask={[/\d/,/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,' ',/\d/,' ',/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/]}
      keepCharPositions
			guide
    />
  );
}

const MaskedTextField = forwardRef<any, any>((props, ref) => {
	const { value, onChange } = props;

	return (
		<TextField
			{...props}
			ref={ref}
			InputProps={{
				inputComponent: TextMask,
				value,
				onChange,
			}}
		/>
	);
})

const FundsRegisterNumberTextField: React.SFC<FundsRegisterNumberTextFieldProps> = forwardRef((props, ref) => {
	const {
		value,
		fullWidth,
		onChange,
		...rest
	} = props;

	const handleChange = useCallback((e: React.SyntheticEvent<HTMLInputElement>) => {
		const value = e.currentTarget.value.replace(/\s|\_/g, '');

		(!value || value.length === 20) && onChange(e, value);
	}, []);

	return (
		<Root fullWidth={fullWidth}>
			<MaskedTextField
				label='Номер счета'
				placeholder='00000 810 0 00000000000'
				{...rest}
				ref={ref}
				value={value}
				fullWidth
				onChange={handleChange}
			/>
		</Root>
	);
});

FundsRegisterNumberTextField.displayName = 'FundsRegisterNumberTextField';
FundsRegisterNumberTextField.defaultProps = {};

export default FundsRegisterNumberTextField;
